import React, {useEffect} from 'react';
import {Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import {getPatientsWithCriticalRPMDataHrDr} from '../../actions/adminActions';
import { sysCategory } from '../../utils/bpCategory';
import { useSortableTable, SortableTh, personName } from '../SortableTable';
import { formatDateTime } from '../../utils/dateFormat';

const CRITICAL_SORT_COLUMNS = {
    patient: { type: 'name', value: (p) => personName(p?.assigned_patient_id) },
    bp: { type: 'number', value: (p) => p?.telemetaryData?.sys },
    pulse: { type: 'number', value: (p) => p?.telemetaryData?.pul },
    when: { type: 'date', value: (p) => p?.telemetaryData?.ts || p?.dateAdded },
};



const PatientsWithCriticalDataDoctor = ({isDr, isNurse, userId}) => {
    
    const dispatch = useDispatch();

    const {criticalPts} = useSelector(state => state.criticalPatients);

    const tableSort = useSortableTable(criticalPts, { id: 'provider.criticalReadings', columns: CRITICAL_SORT_COLUMNS, defaultSort: { key: 'when', dir: 'desc' } });
    useEffect(() => {
        dispatch(getPatientsWithCriticalRPMDataHrDr(isDr, isNurse, userId));
      }, [dispatch]);


      let sysBPCategory; //variable to store category of BP
let color

    function calcSysBpCategory(sys) {
        const c = sysCategory(sys);
        sysBPCategory = c.label;
        color = c.color;
    }
    
        const refreshCriticalReading = () => {
            dispatch(getPatientsWithCriticalRPMDataHrDr(isDr, isNurse, userId));
        }
 
    return (
    <>

        <div className="shadow-lg bg-white p-3 mb-2 rounded  recent-readings-card">
        <div className="row-display">
            <h5 className="title">Critical Readings</h5>
            <button className="edit-pill" onClick={() => refreshCriticalReading()}>Refresh List</button>
        </div>
        <p>There are total <span style={{color: 'red', fontWeight: 'bold'}}>{criticalPts.length}</span> critical readings during past three days. </p>

        <Table bordered className="text-center">
            <thead>
                <tr>
                    <SortableTh sortKey="patient" sort={tableSort}>Patient</SortableTh>
                    <SortableTh sortKey="bp" sort={tableSort}>B.P</SortableTh>
                    <SortableTh sortKey="pulse" sort={tableSort} style={{width: '70px'}}>Pulse</SortableTh>
                    <SortableTh sortKey="when" sort={tableSort}>Date & Time</SortableTh>
                    <th style={{width: '70px'}}>Code</th>
                    <th>Status</th>
                    <th>Responded</th>
                </tr>
                </thead>
                <tbody>
                {tableSort.rows.map((pts, index) => (
                <tr key={index} className={pts?.notes && pts?.notes?.length > 0 ? 'coloredRow' : 'reddishRow'}>
                    <td>
                    {isDr === true ? <>
                        <Link to={{ pathname: "/doctor/patient/profile", state: {patientid: pts?.assigned_patient_id?._id}}} className="link">{pts?.assigned_patient_id?.firstname + " "+ pts?.assigned_patient_id?.lastname } </Link>   
                            </> : <>
                        <Link to={{ pathname: "/Nurse/Patient/Profile", state: {patientid: pts?.assigned_patient_id?._id}}} className="link">{pts?.assigned_patient_id?.firstname + " "+ pts?.assigned_patient_id?.lastname } </Link>   
                        </>}
                    </td>

                    {calcSysBpCategory(pts?.telemetaryData?.sys)}
                    <td> {
                        pts?.telemetaryData?.sys >= 139 || pts?.telemetaryData?.sys <= 110 ? 
                        <span style={{color: 'red', fontWeight: 'bold'}}>{pts?.telemetaryData?.sys}</span> : 
                        <span>{pts?.telemetaryData?.sys}</span>} &nbsp; / &nbsp; 
                        {pts?.telemetaryData?.dia >= 90 || pts?.telemetaryData?.dia <= 70 ? 
                        <span style={{color: 'red', fontWeight: 'bold'}}>{pts?.telemetaryData?.dia}</span> : 
                        <span>{pts?.telemetaryData?.dia}</span>}
                    </td>
                    <td>{pts?.telemetaryData?.pul}</td>
                    <td>{formatDateTime(pts?.telemetaryData?.ts * 1000)}</td>
                    <td>
                        <i className='bx bxs-circle' style={{color: color, fontSize: '22px'}}></i>
                    </td>
                    <td>{sysBPCategory}</td>
                    <td>{pts?.notes?.length > 0 ? <i className="fas fa-check" style={{color: 'green'}}></i> : 
                        <i className="fas fa-times" style={{color: 'red'}}></i>}
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    </div>

         {/* <div className="container-fluid mt-3 mb-5">
           <h5 className="title">Patients with critical readings</h5>   
            <p><small>List of RPM patients with critical readings during the last seven days.</small></p>

            <div className="row">
            {criticalPts && criticalPts.filter((a, i) => criticalPts.findIndex((s) => a?.assigned_patient_id?._id === s?.assigned_patient_id?._id) === i).map((pts, index) => (
                <div className="col-md-3 mb-4">
                <div className="card">
                    <div className={`ribbon ribbon-top-left`}> 
                    <span style={{backgroundColor: '#FC359B'}}>{index + 1}</span>
                    </div>

                    <div className="container text-center">
                     <div className="text-center">
                         <img src={patientProfileImg} className="img-responsive profile-card-img mt-4" alt="patientProfile" />
                     </div>    
                     <label className="profile-label mt-3">Patient Name : </label>
                        &nbsp;
                        {isDr === true ? <>
                            <Link to={{ pathname: "/doctor/patient/profile", state: {patientid: pts?.assigned_patient_id?._id}}} className="link">{pts?.assigned_patient_id?.firstname + " "+ pts?.assigned_patient_id?.lastname } </Link>   
                        </> : <>
                        <Link to={{ pathname: "/Nurse/Patient/Profile", state: {patientid: pts?.assigned_patient_id?._id}}} className="link">{pts?.assigned_patient_id?.firstname + " "+ pts?.assigned_patient_id?.lastname } </Link>   
                        </>}
                    <br/>
                
                     <label className="profile-label mt-3">Reading Details </label>

                     <div className="row-display">
                        <div>
                            <span><b>Sys</b></span>
                            <p style={{color: '#FC359B'}}>{pts?.telemetaryData?.sys}</p>
                        </div>

                        <div>
                            <i className='bx bxs-circle' style={{color: '#FC359B', fontSize: '36px'}}></i>    
                        </div>

                        <div>
                            <span><b>Dia</b></span>
                            <p>{pts?.telemetaryData?.dia}</p>
                        </div>

                        <div>
                            <span><b>Pulse</b></span>
                            <p>{pts?.telemetaryData?.pul}</p>
                        </div>
                     </div>

                    <label className="profile-label mt-3">Data Received Date : </label>
                    <p>{formatDate(pts?.dateAdded)}</p>

                    </div>
                </div>  
                </div>
            ))}
            </div>
        
        </div> */}
    </>
  )
}

export default PatientsWithCriticalDataDoctor